import React from "react";
import { useInView } from "react-intersection-observer";

interface IProps {
    children: React.ReactNode;
}

const LazyLoading = ({
    children
}: IProps) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  return (
    <div ref={ref}>
      {inView ? (
        children
      ) : (
        <div>loading...</div>
      )}
    </div>
  )
}

export default LazyLoading